import React, { useEffect, useState } from 'react';
import { Alert, Badge, Card, Table } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import UserLayout from '../../components/user/UserLayout';
import api from '../../lib/api';

export default function UserWidgetChatsPage() {
  const { token } = useParams();
  const [rows, setRows] = useState([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    api.get(`/user/widgets/chats/${token}/`)
      .then((res) => setRows(res.data?.results || []))
      .catch(() => setMsg('Unable to load widget chat logs.'));
  }, [token]);

  return (
    <UserLayout title="Widget Chat Logs" subtitle={`Viewing chats for widget token: ${token}`}>
      {msg ? <Alert variant="info">{msg}</Alert> : null}
      <Card className="user-card p-4">
        <div className="user-section-title">Chats</div>
        <div className="table-responsive user-table-wrap">
          <Table hover>
            <thead>
              <tr>
                <th>Date</th>
                <th>Guest</th>
                <th>Email</th>
                <th>Question</th>
                <th>Response</th>
                <th>Feedback</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((chat) => (
                <tr key={chat.id}>
                  <td>{new Date(chat.created_at).toLocaleString()}</td>
                  <td>{chat.guest_name || '-'}</td>
                  <td>{chat.email || '-'}</td>
                  <td>{chat.question}</td>
                  <td>{chat.response}</td>
                  <td>
                    <Badge bg={chat.feedback === 'positive' ? 'success' : chat.feedback === 'negative' ? 'danger' : 'secondary'}>
                      {chat.feedback || 'none'}
                    </Badge>
                  </td>
                </tr>
              ))}
              {!rows.length ? <tr><td colSpan={6} className="text-center text-muted py-4">No chats yet for this widget.</td></tr> : null}
            </tbody>
          </Table>
        </div>
      </Card>
    </UserLayout>
  );
}
